import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

interface VideoModalProps {
  src: string;
  onClose: () => void;
}

export function VideoModal({ src, onClose }: VideoModalProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return createPortal(
    <div
      className="fixed inset-0 z-[9999]"
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
        style={{ zIndex: 0 }}
      />
      <div
        className="relative w-full max-w-3xl mx-4 rounded-3xl overflow-hidden border border-white/10 shadow-[0_24px_80px_rgba(0,0,0,0.4)] animate-modal-in"
        style={{ zIndex: 1 }}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 p-2 rounded-xl bg-black/50 backdrop-blur-sm text-white/70 hover:text-white hover:bg-black/60 transition-all border border-white/10"
        >
          <X className="size-5" />
        </button>
        <video
          src={src}
          className="w-full"
          style={{ maxHeight: "50vh" }}
          controls
          autoPlay
          loop
          playsInline
        />
      </div>
    </div>,
    document.body,
  );
}
